import { takeLatest, call, put, all, select } from "redux-saga/effects";

import {
  getAllTeamLeaderUsers,
  deleteTeamLeaderUser,
  createTlUser,
  getTotalPayout,
  getDailySalesStats,
  getTotalDailyPayout,
  viewCart,
  viewCartLite,
} from "@services/api";

import { actions } from "@reducers/leaderReducer";
import { actions as cartActions } from "@reducers/cartReducer";
import { actions as customerActions } from "@reducers/customerReducer";
import {
  GET_ALL_TL_USERS,
  SET_ALL_TL_USERS,
  DELETE_TL_USER,
  DELETE_TL_USER_SUCCESS,
  ADD_TL_USER,
  ADD_TL_USER_SUCCESS,
  GET_TOTAL_PAYOUT_REQUEST,
  GET_DAILY_SALES_REQUEST,
  GET_DAILY_PAYOUT_REQUEST,
  GET_TOTAL_PAYOUT_SUCCESS,
  GET_DAILY_SALES_SUCCESS,
  GET_DAILY_PAYOUT_SUCCESS,
  GET_ALL_CART_ITEMS_SUCCESS,
  GET_ALL_CART_ITEMS_REQUEST,
  VIEW_CART_LITE_REQUEST,
} from "../reducers/actionTypes";

// import NavigationService from "@utils/NavigationService";

function* getAllTLUsers({ payload }) {
  const { replace = false } = payload;

  try {
    const { data } = yield call(getAllTeamLeaderUsers, payload);
    yield put({
      type: SET_ALL_TL_USERS,
      payload: {
        users: data,
        replace,
      },
    });
  } catch (error) {
    console.log(error);
  }
}

function* deleteTlUser(params, _) {
  try {
    const { payload } = params;

    const { data } = yield call(deleteTeamLeaderUser, {
      userId: payload.userId,
    });

    // LET assume this time deleting user is successful
    yield put({
      type: DELETE_TL_USER_SUCCESS,
      payload: {
        data,
      },
    });
  } catch (error) {
    console.log(error);
  }
}

function* addTlUser(params) {
  try {
    const {
      payload: { userCreds },
    } = params;
    const { data } = yield call(createTlUser, { userCreds });

    yield put({
      type: ADD_TL_USER_SUCCESS,
      payload: {
        data,
      },
    });

    const usersPayload = {
      offset: 0,
      limit: 10,
      replace: true,
    };
    yield put(actions.getAllUsers(usersPayload));
  } catch (error) {
    console.log(error);
  }
}

function* getTotalPayoutReq() {
  try {
    const { data } = yield call(getTotalPayout);

    yield put({
      type: GET_TOTAL_PAYOUT_SUCCESS,
      payload: data,
    });
  } catch (error) {
    console.log(error);
  }
}

function* getDailySalesStatsReq() {
  try {
    const { data } = yield call(getDailySalesStats);

    yield put({
      type: GET_DAILY_SALES_SUCCESS,
      payload: data,
    });
  } catch (error) {
    console.log(error);
  }
}

function* getTotalDailyPayoutReq() {
  try {
    const { data } = yield call(getTotalDailyPayout);

    yield put({
      type: GET_DAILY_PAYOUT_SUCCESS,
      payload: data,
    });
  } catch (error) {
    console.log(error);
  }
}

function* getCartItemsReq(action) {
  try {
    const { data } = yield call(viewCart, { userId: action.payload });

    const filterArr =
      data &&
      data.result.reduce((acc, cur) => {
        if (cur.quantity && !cur.discounted_product) {
          if (acc[cur.user_id]) {
            acc[cur.user_id][`${cur.sku_id}`] = cur.quantity;
          } else {
            acc[`${cur.user_id}`] = { [`${cur.sku_id}`]: cur.quantity };
          }
        }
        return acc;
      }, {});

    yield put({
      type: GET_ALL_CART_ITEMS_SUCCESS,
      payload: {
        data: data.result,
        filterData: filterArr,
        cartDetails: data.cartTotal,
      },
    });
  } catch (error) {
    console.log(error);
  }
}

function* viewCartLiteRequest({ payload }) {
  try {
    const { user_id = "", user_name = "" } = payload || {};
    const { data } = yield call(viewCartLite, { userId: user_id });

    // const filterArr =
    //   data &&
    //   data.result.reduce((acc, cur) => {
    //     if (cur.quantity) {
    //       if (acc[cart.userForOrder.user_id]) {
    //         acc[cart.userForOrder.user_id][`${cur.sku_id}`] = cur.quantity;
    //       } else {
    //         acc[`${cart.userForOrder.user_id}`] = { [`${cur.sku_id}`]: cur.quantity };
    //       }
    //     }
    //     return acc;
    //   }, {});

    yield put(customerActions.setSelectedContact(payload));
    yield put(cartActions.viewCartLiteSuccess(data, user_id));
  } catch (error) {
    console.log(error);
  }
}

export default function* root() {
  yield all([
    takeLatest(GET_ALL_TL_USERS, getAllTLUsers),
    takeLatest(DELETE_TL_USER, deleteTlUser),
    takeLatest(ADD_TL_USER, addTlUser),
    takeLatest(GET_TOTAL_PAYOUT_REQUEST, getTotalPayoutReq),
    takeLatest(GET_DAILY_SALES_REQUEST, getDailySalesStatsReq),
    takeLatest(GET_DAILY_PAYOUT_REQUEST, getTotalDailyPayoutReq),
    takeLatest(GET_ALL_CART_ITEMS_REQUEST, getCartItemsReq),
    takeLatest(VIEW_CART_LITE_REQUEST, viewCartLiteRequest),
  ]);
}
